import { UserIcon } from '@shared/ui';
import { useAuthStore } from '@app/authStore';

export function AccountMenu() {
  const status = useAuthStore((s) => s.status);
  const openModal = useAuthStore((s) => s.openModal);
  const logout = useAuthStore((s) => s.logout);

  if (status === 'signed-in') {
    return (
      <button
        type="button"
        onClick={() => void logout()}
        className="flex items-center gap-2 rounded-full border border-surface-border bg-surface-2 px-3 py-1.5 text-sm text-text-primary hover:bg-surface-3"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-surface-3">
          <UserIcon className="h-3.5 w-3.5 text-text-secondary" />
        </span>
        Logout
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => openModal('login')}
      className="flex items-center gap-2 rounded-full border border-surface-border bg-surface-2 px-3 py-1.5 text-sm text-text-primary hover:bg-surface-3"
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-surface-3">
        <UserIcon className="h-3.5 w-3.5 text-text-secondary" />
      </span>
      Sign In
    </button>
  );
}